import '../i18n';
import {useTranslation} from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
    LOCAL_IMPERSONATION_EVENT,
    getLocalImpersonationUserId,
    isLocalImpersonationUiEnabled,
    stopLocalImpersonationAndOpenAdmin
} from '../utils/localImpersonation';

const wrapperStyle = {
    position: 'fixed',
    top: 14,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 5000,
    pointerEvents: 'none'
};

const buttonStyle = {
    pointerEvents: 'auto',
    border: '1px solid rgba(29, 92, 99, 0.22)',
    borderRadius: 999,
    padding: '8px 14px',
    background: 'rgba(255, 247, 230, 0.96)',
    color: '#7a4b00',
    boxShadow: '0 8px 24px rgba(29, 42, 51, 0.12)',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 700,
    backdropFilter: 'blur(10px)'
};

function LocalImpersonationStopButton() {
    const {t: lnT} = useTranslation();

    const [activeUserId, setActiveUserId] = useState(() => getLocalImpersonationUserId());

    useEffect(() => {
        const refreshState = () => {
            setActiveUserId(getLocalImpersonationUserId());
        };

        window.addEventListener(LOCAL_IMPERSONATION_EVENT, refreshState);
        window.addEventListener('focus', refreshState);

        return () => {
            window.removeEventListener(LOCAL_IMPERSONATION_EVENT, refreshState);
            window.removeEventListener('focus', refreshState);
        };
    }, []);

    if (!isLocalImpersonationUiEnabled() || !activeUserId) {
        return null;
    }

    const handleStop = () => {
        stopLocalImpersonationAndOpenAdmin();
    };

    return (
        <div style={wrapperStyle}>
            <button type="button" style={buttonStyle} onClick={handleStop}>{lnT('common:stopImpersonation')}</button>
        </div>
    );
}

export default LocalImpersonationStopButton;
